import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DebounceClickDirective } from './click-debounce.directive';
import { DebounceKeyupDirective } from './keyup-debounce.directive';
import { DebounceInputDirective } from './debounce-input.directive';
@NgModule({
  declarations: [DebounceClickDirective, DebounceKeyupDirective, DebounceInputDirective],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [DebounceClickDirective, DebounceKeyupDirective, DebounceInputDirective]
})
export class DebounceDirectiveModule { }
